<template>
  <el-table :data="dataList" stripe>
    <el-table-column align="left" label="时间" width="165">
      <template slot-scope="scope">{{ $common.parseTime(scope.row.labelChangeTime, '{y}年{m}月{d}日 {h}:{i}:{s}') }}</template>
    </el-table-column>
    <el-table-column align="left" label="事件类型" width="120">
      <template slot-scope="scope">{{ scope.row.eventType }}</template>
    </el-table-column>
    <el-table-column align="left" label="客户动态内容" min-width="160">
      <template slot-scope="scope">
        <span v-html="scope.row.content.replaceAll('\n', '')"></span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    dealerId: {
      type: String | Number,
      default: "",
    },
    customerId: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    this.getCustomerDynamics();
  },
  methods: {
    getCustomerDynamics() {
      this.$httpAuth
        .post("/v2/appCustomerService/cdpTagDynamics", {
          dealerId: this.dealerId,
          customerId: this.customerId,
        })
        .then((response) => {
          this.dataList = response.data.data || [];
        });
    },
  },
};
</script>